import {Directive, ElementRef, HostListener} from '@angular/core';
import {openFullscreen} from "../helpers/general-helpers";

@Directive({
  selector: '[mesEnsureFullScreen]'
})
export class EnsureFullScreenDirective {
  @HostListener('click', ['$event']) onClick($event){
    openFullscreen();
  }

}
